import moment from "moment/moment";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

function getPreviousMonthName(date: string): string {
	if (date) {
		return moment(date).utc().add(-1, "months").format(DATE_FORMAT.monthLong);
	}
	return "";
}

export { getPreviousMonthName };
